<div class="first-access" >
  <form class="form" [formGroup]="formGroup">
    <h1>{{ 'login.firstAccess' | translate | uppercase }}</h1>
    <h2>{{ 'login.changePassword' | translate }}</h2>

    <mat-form-field class="first-access-input">
      <input matInput name="newPassword" type="password"
        [placeholder]="'login.newPassword' | translate"
        formControlName="newPassword" required />
    </mat-form-field>

    <mat-form-field class="first-access-input">
      <input matInput name="confirmNewPassword" type="password"
        [placeholder]="'login.confirmNewPassword' | translate"
        formControlName="confirmNewPassword" required />
    </mat-form-field>

    <div class="spacer"></div>
    <button class="button-input"
      (click)="saveAndContinue(formGroup)">
      {{ 'generic.save' | translate | uppercase }}
    </button>
  </form>
</div>